import { ImagesSubComponent } from '../images.sub.component';
import { openProductRoomFitSheet } from './product-room-fit-sheet';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class ProductRoomFitSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_product-room-fit';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.createAndAppendButton();
        this.performViewTracking();
    }

    private createAndAppendButton() {
        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }
        const buttonElement = document.createElement('oc-button-v1');
        buttonElement.classList.add('pdp_product-room-fit__button');
        buttonElement.setAttribute('icon-type-left', 'sparkles');
        buttonElement.setAttribute('size', '50');
        buttonElement.setAttribute('variant', 'secondary');
        buttonElement.innerHTML = '<b>In meinen Raum generieren</b>';
        buttonElement.addEventListener('click', () => openProductRoomFitSheet(variationId));
        this.getRootElement().appendChild(buttonElement);
        this.getRootElement().classList.add('pdp_product-room-fit');
    }

    private performViewTracking() {
        trackView({
            product_InteriorDesignConsultant: ['True'],
        });
    }

    protected onItemChanged() {}
}
